import { render, staticRenderFns } from "./signal.vue?vue&type=template&id=194ffde3&scoped=true"
import script from "./signal.vue?vue&type=script&lang=js"
export * from "./signal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ffde3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194ffde3')) {
      api.createRecord('194ffde3', component.options)
    } else {
      api.reload('194ffde3', component.options)
    }
    module.hot.accept("./signal.vue?vue&type=template&id=194ffde3&scoped=true", function () {
      api.rerender('194ffde3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/signal.vue"
export default component.exports